import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { OccupationItem } from '../../../types/personShow';

type Props = {
  isPc: boolean;
  isSuccessPlan: boolean;
  personId: number;
  noIconPersonImg: string;
  instagramIcon: string;
  twitterIcon: string;
  xIcon: string;
  penIconImg: string;
  icon: string;
  fullName: string;
  follows: number | null;
  gender: string;
  location: string;
  birthday: string;
  age: number | string;
  graduationYear: string;
  tel: string;
  mail: string;
  instagram: string;
  twitter: string;
  isShow: boolean;
  fromPage: string;
  unCompletedProfile: boolean;
  isStudent: boolean;
  currentOccupations: OccupationItem[];
  salary: number | null;
  positions: string;
  resume: "" | File | { name: { url: string; } };
  jobResume: "" | File | { name: { url: string; } };
  handleOpenModal: (target: string, title: string) => void;
  handleFetchSidebarDetails: () => void;
  handleUploadIcon: (file: File) => void;
  offline011: string;
  showOffline011Banner: boolean;
  memo?: string;
  isMemoModalOpen?: boolean;
  handleMemoChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleOpenMemoModal?: () => void;
  handleCloseMemoModal?: () => void;
  isOneYearPassed?: boolean;
};

export const Component: FunctionComponent<Props> = ({
  isPc,
  isSuccessPlan,
  personId,
  noIconPersonImg,
  instagramIcon,
  twitterIcon,
  xIcon,
  penIconImg,
  icon,
  fullName,
  follows,
  gender,
  location,
  birthday,
  age,
  graduationYear,
  tel,
  mail,
  instagram,
  twitter,
  isShow,
  fromPage,
  unCompletedProfile,
  isStudent,
  currentOccupations,
  salary,
  positions,
  resume,
  jobResume,
  handleOpenModal,
  handleFetchSidebarDetails,
  handleUploadIcon,
  offline011,
  showOffline011Banner,
  memo,
  isMemoModalOpen,
  handleMemoChange,
  handleOpenMemoModal,
  handleCloseMemoModal,
  isOneYearPassed,
}) => {
  const [stateAge, setStateAge] = useState<string>('')

  useEffect(() => {
    handleFetchSidebarDetails();
  }, []);

  useEffect(() => {
    if (birthday) {
      const today = new Date();
      const birthYear = parseInt(birthday.split('年')[0], 10);
      const birthMonth = parseInt(birthday.split('年')[1]?.split('月')[0], 10) - 1;
      const birthDay = parseInt(birthday.split('年')[1]?.split('月')[1]?.split('日')[0], 10);

      const thisYearBirthday = new Date(today.getFullYear(), birthMonth, birthDay);
      let ageCalc = today.getFullYear() - birthYear;
      if (today < thisYearBirthday) ageCalc--;
      setStateAge(String(ageCalc));
    }
  }, [birthday]);

  return (
    <Presentation
      age={stateAge}
      isPc={isPc}
      isSuccessPlan={isSuccessPlan}
      personId={personId}
      noIconPersonImg={noIconPersonImg}
      instagramIcon={instagramIcon}
      twitterIcon={twitterIcon}
      xIcon={xIcon}
      penIconImg={penIconImg}
      icon={icon}
      fullName={fullName}
      follows={follows}
      gender={gender}
      location={location}
      birthday={birthday}
      graduationYear={graduationYear}
      tel={tel}
      mail={mail}
      instagram={instagram}
      twitter={twitter}
      isShow={isShow}
      fromPage={fromPage}
      unCompletedProfile={unCompletedProfile}
      isOneYearPassed={isOneYearPassed}
      isStudent={isStudent}
      currentOccupations={currentOccupations}
      salary={salary}
      positions={positions}
      resume={resume}
      jobResume={jobResume}
      handleOpenModal={handleOpenModal}
      handleUploadIcon={handleUploadIcon}
      offline011={offline011}
      showOffline011Banner={showOffline011Banner}
      memo={memo}
      isMemoModalOpen={isMemoModalOpen}
      handleMemoChange={handleMemoChange}
      handleOpenMemoModal={handleOpenMemoModal}
      handleCloseMemoModal={handleCloseMemoModal}
    />
  );
};
